export default "/kiban/_next/static/images/ddrEmc-b093a0982a723edcacfc5c0888b677d7.png";